import {createSlice, PayloadAction} from '@reduxjs/toolkit';

import {NET_DIRECTORY_FILE_SLICE} from './net-directory-file-slice-constants';
import {INetDirectoryFileSliceState, INetDirectoryFileData} from './net-directory-file-slice-type';
import {
    loadNetDirectoryFileNameList,
} from './net-directory-file-slice.thunk';

export const netDirectoryFileSlice = createSlice({
    name: NET_DIRECTORY_FILE_SLICE,
    initialState: {
        fileNameList: [],
        netDirectoryFileData: [],
    } as INetDirectoryFileSliceState,
    reducers: {
        resetNetDirectoryFile(state) {
            state.fileNameList = [];
            state.netDirectoryFileData = [];
        },
        setNetDirectoryFileData(state, {payload}: PayloadAction<INetDirectoryFileData[]>) {
            state.netDirectoryFileData = [...payload];
        },
    },
    extraReducers: builder => {
        builder.addCase(loadNetDirectoryFileNameList.fulfilled, (state, action) => {
            state.fileNameList = [...action.payload];
        });
    },
});

export const {
    reducer: netDirectoryFileSliceReducer,
    actions: netDirectoryFileSliceActions,
} = netDirectoryFileSlice;
